export default "__VITE_PUBLIC_ASSET__11f5c64d__"